import { Fragment, useState } from "react";
import { MGMicrotext } from "../../../../../designSystem/components/MGMicrotext";
import { MGNote } from "../../../../../designSystem/components/MGNote";
import { MGInputRadioButton } from "../../../../../designSystem/components/MGInputRadioButton";
import { MGChip } from "../../../../../designSystem/components/MGChip";
import { moduleOptions, TGender, TModuleOption } from "./types";
import { MGButton } from "../../../../../designSystem/components/MGButton";
import { genderOptions } from "../../../FormStep/types";
import styles from "./ModuleBottomSheet.module.css";
import { MGCard } from "../../../../../designSystem/components/MGCard";
import { MGLabel } from "../../../../../designSystem/components/MGLabel";
import { TFormHealth } from "../../..";
import { MGTag } from "../../../../../designSystem/components/MGTag";

type TModuleBottomSheetProps = {
  formHealth: TFormHealth;
  module?: TModuleOption;
  recommendedModule?: TModuleOption;
  gender?: TGender;
  onSave: (module: TModuleOption, gender: TGender) => void;
  onClose: VoidFunction;
};

export const ModuleBottomSheet = ({
  formHealth,
  module,
  recommendedModule,
  gender,
  onSave,
  onClose,
}: TModuleBottomSheetProps) => {
  const [selectedModule, setSelectedModule] = useState<TModuleOption | undefined>(module);
  const [selectedGender, setSelectedGender] = useState<TGender | undefined>(gender);

  return (
    <Fragment>
      <div style={{ display: "flex", gap: 8, marginBottom: 32 }}>
        {genderOptions.map((option) => (
          <MGChip
            key={option.value}
            label={option.name}
            selected={option.value === selectedGender}
            onClick={() => {
              setSelectedGender(option.value);
              setSelectedModule(undefined);
            }}
          />
        ))}
      </div>

      <MGMicrotext microtextStyleDefinition="microcopy-100-05" style={{ marginBottom: 8 }}>
        {"Escolha uma opção "}
      </MGMicrotext>

      <MGCard paddingRight="none" paddingLeft="none" style={{ marginBottom: 24 }}>
        <div className={styles.radioList}>
          {moduleOptions
            .filter((m) => {
              return (
                selectedGender === "OTHER" || m.gender === selectedGender || m.gender === "OTHER"
              );
            })
            .map((option) => (
              <div key={option.value} className={styles.radioOption}>
                <MGInputRadioButton
                  id={`module-${option.value}`}
                  value={option.value}
                  checked={selectedModule?.value === option.value}
                  onChange={() => setSelectedModule(option)}
                />
                <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                  <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <MGMicrotext
                      tagName="label"
                      htmlFor={`module-${option.value}`}
                      microtextStyleDefinition={"microcopy-60-07"}
                      color="text-primary-03">
                      {option.moduleLabel}
                    </MGMicrotext>

                    {recommendedModule?.value === option.value && (
                      <MGTag appearance={"success"} label="RECOMENDADO" size="xxs" />
                    )}
                  </div>
                  <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <MGLabel
                      tagName="label"
                      htmlFor={`module-${option.value}`}
                      labelStyleDefinition={
                        selectedModule?.value === option.value ? "80-05" : "80-03"
                      }
                      style={{ flex: 1 }}>
                      {option.genderLabel}
                    </MGLabel>
                    <MGLabel
                      tagName="label"
                      htmlFor={`module-${option.value}`}
                      labelStyleDefinition={
                        selectedModule?.value === option.value ? "80-06" : "80-05"
                      }>
                      {option.name}
                    </MGLabel>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </MGCard>

      {selectedGender &&
        selectedModule &&
        ((selectedGender !== "OTHER" && formHealth.gender !== selectedGender) ||
          recommendedModule?.value !== selectedModule.value) && (
          <MGNote
            description="Os atos clínicos associados a cada módulo foram definidos de acordo com a sua faixa etária. Confirma que pretende alterar o módulo selecionado?"
            icon="info"
          />
        )}

      <div className={styles.buttonGroup}>
        <MGButton
          className={styles.button}
          disabled={
            !selectedModule ||
            (gender === selectedGender && module?.value === selectedModule?.value)
          }
          onClick={() =>
            !!selectedModule && !!selectedGender && onSave(selectedModule, selectedGender)
          }>
          {"Guardar"}
        </MGButton>
        <MGButton appearance="secondary" onClick={onClose} className={styles.button}>
          {"Cancelar"}
        </MGButton>
      </div>
    </Fragment>
  );
};
